const create = () => {
  const parseWKTPoint = (point) => {
    const [, match] = point.match(/POINT ?\((.*)\)/, point);
    const [lng, lat] = match.split(' ');
    return {
      lng,
      lat,
    };
  };

  const mergeBBoxes = (bboxes) => bboxes.reduce((aggregate, bbox) => {
    const [left, bottom, right, top] = bbox;
    const [minLeft = left, minBottom = bottom, maxRight = right, maxTop = top] = aggregate;

    return [
      left < minLeft ? left : minLeft,
      bottom < minBottom ? bottom : minBottom,
      right > maxRight ? right : maxRight,
      top > maxTop ? top : maxTop,
    ];
  }, []);

  return {
    parseWKTPoint,
    mergeBBoxes,
  };
};

const utilPlugin = {
  create,
};

export default utilPlugin;
